<template>
    <div>
        <UserRoles/>
    </div>
  
</template>

<script>
import UserRoles from '@/components/DPEBB/Administrator/UserRoles.vue'
import LayoutDefault from '../../Common/Default/DefaultLayout.vue';
export default {
    data: function () {
    return {              
         AppServiceID :6,

      }
    },  
     components: { 
            UserRoles
        },
    created: function() {
            this.$emit('update:layout', LayoutDefault);
    },
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
    },
}
</script>

<style>

</style>
